import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LookupModalService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getLookup(params: object): Promise<Object> {
    return this.http.post('/Office/getLookup', params).toPromise();
  }
}
